import featureFlagOverrides from "virtual:config-cat-feature-flag-overrides";

export const getConfigCatFeatureFlagOverrides = () => featureFlagOverrides;
